<!-- breadcrumb -->
<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Transacciones</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Descuentos</span>
    </div>
  </div>
  <div class="d-flex my-xl-auto right-content mr-2">
    <button type="button" class="btn btn-primary" (click)="crearDescuento()">
      Crear Descuento
    </button>
  </div>
</div>

<!-- Filtros -->
<div class="row row-sm mb-3">
  <div class="col-12">
    <div class="card">
      <div class="card-header">
        <h6 class="card-title mb-0">Filtrar</h6>
      </div>
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-12 col-md-4">
            <label class="form-label">Desde</label>
            <input type="date" class="form-control" [(ngModel)]="fechaInicio">
          </div>
          <div class="col-12 col-md-4">
            <label class="form-label">Hasta</label>
            <input type="date" class="form-control" [(ngModel)]="fechaFin">
          </div>
          <div class="col-12 col-md-4">
            <button class="btn btn-secondary w-100" (click)="aplicarFiltros()">
              <i class="fe fe-filter me-1"></i> Aplicar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Tabla -->
<div class="row row-sm">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                 class="table table-bordered table-striped table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>Secuencial</th>
                <th>Fecha</th>
                <th>Paciente</th>
                <th>Cédula</th>
                <th>Doctor</th>
                <th>Método Pago</th>
                <th>Total</th>
                <th>Responsable</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              @for (d of descuentos; track d.COD_TRAC; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td><span class="badge bg-primary">{{ d.NUM_TRACDES }}</span></td>
                  <td>{{ formatFecha(d.FEC_TRAC) }}</td>
                  <td>{{ d.NOM_CLI }}</td>
                  <td>{{ d.CED_CLI }}</td>
                  <td>{{ d.OBS_TRAC }}</td>
                  <td>{{ d.METPAG_TRAC }}</td>
                  <td><strong>$ {{ d.TOT_TRAC }}</strong></td>
                  <td>{{ d.nombre_usuario }}</td>
                  <td class="text-center">
                    <button class="btn btn-sm btn-danger"
                            title="Eliminar descuento"
                            (click)="eliminarDescuento(d.COD_TRAC, d.NUM_TRACDES)">
                      <i class="fe fe-trash-2"></i>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
